/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/051-folder-minus': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M9 4L7 2H0v13h16V4H9zm2 7H5V9h6v2z"/>'
  }
})
